
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternPortColourOff as ObiLightLanternPortColourOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-port-colour-off.js';
 
 
 

 
 export const ObiLightLanternPortColourOff = createComponent({
   react: React,
   tagName: 'obi-light-lantern-port-colour-off',
   elementClass: ObiLightLanternPortColourOffElement,
   events: {
     
   }
  });
 
 